/** Mapeamento defensivo de status legados → modelo FR-001 (rollout). */
const MAPA_STATUS_LEGADO = {
  OPENING: "CONNECTING",
  opening: "CONNECTING",
  qrcode: "QRCODE",
  QRCODE: "QRCODE",
  PAIRING: "DEGRADED",
  TIMEOUT: "DEGRADED",
  PENDING: "DISCONNECTED",
}

const STATUS_CONJUNTO_FECHADO = new Set([
  "DISCONNECTED",
  "CONNECTING",
  "CONNECTED",
  "DEGRADED",
  "QRCODE",
])

export const DESCONEXAO_SYNC_TIMEOUT_MS = 15000

/** Falhas de pareamento já refletidas no status do canal — sem toast de erro. */
export function criarSessaoFalhaEhPareamentoEsperado(cMensagemErro) {
  const cMensagem = (cMensagemErro || "").trim()
  if (!cMensagem) {
    return false
  }
  return (
    /excedido limite de tentativas de qrcode/i.test(cMensagem) ||
    /conex[aã]o encerrada antes de concluir abertura/i.test(cMensagem)
  )
}

export function normalizarStatusConexao(cStatus) {
  if (!cStatus) {
    return "DISCONNECTED"
  }
  const cMapeado = MAPA_STATUS_LEGADO[cStatus]
  if (cMapeado) {
    return cMapeado
  }
  const cUpper = String(cStatus).toUpperCase()
  if (STATUS_CONJUNTO_FECHADO.has(cUpper)) {
    return cUpper
  }
  return cStatus
}

export function lStatusDesconectado(cStatus) {
  const cNormalizado = normalizarStatusConexao(cStatus)
  return cNormalizado === "DISCONNECTED"
}

export function lConexaoAguardandoQr(whatsApp) {
  const cStatus = normalizarStatusConexao(whatsApp?.status)
  return cStatus === "QRCODE" && Boolean(whatsApp?.qrcode)
}

export function lConexaoAguardandoQrSemCodigo(whatsApp) {
  const cStatus = normalizarStatusConexao(whatsApp?.status)
  return cStatus === "QRCODE" && !whatsApp?.qrcode
}

export function lConexaoEmAndamento(cStatus) {
  return normalizarStatusConexao(cStatus) === "CONNECTING"
}

export function lConexaoAtivaComSocket(whatsApp) {
  const cStatus = normalizarStatusConexao(whatsApp?.status)
  if (cStatus !== "CONNECTED" && cStatus !== "DEGRADED") {
    return false
  }
  return whatsApp?.socketAlive !== false
}

export function lConexaoFantasma(whatsApp) {
  const cStatus = normalizarStatusConexao(whatsApp?.status)
  if (cStatus !== "CONNECTED" && cStatus !== "DEGRADED") {
    return false
  }
  return whatsApp?.socketAlive === false
}

/** Pareamento via QR concluído com sucesso — modal de QR deve fechar. */
export function lPareamentoQrConcluido(oCanal) {
  const cStatus = normalizarStatusConexao(oCanal?.status)
  if (cStatus === "CONNECTED") {
    return true
  }
  if (cStatus === "DEGRADED" && oCanal?.socketAlive !== false) {
    return true
  }
  return false
}

/** Canal saiu do fluxo de QR (conectado, desconectado ou sem código). */
export function lModalQrDeveFechar(oCanal) {
  if (lPareamentoQrConcluido(oCanal)) {
    return true
  }
  const cStatus = normalizarStatusConexao(oCanal?.status)
  if (cStatus === "DISCONNECTED") {
    return true
  }
  const cQrcode = oCanal?.qrcode
  if (cStatus !== "QRCODE" && (!cQrcode || String(cQrcode).trim() === "")) {
    return true
  }
  return false
}

export function lPodeDesconectar(cStatus) {
  const cNormalizado = normalizarStatusConexao(cStatus)
  return (
    cNormalizado === "CONNECTED" ||
    cNormalizado === "DEGRADED" ||
    cNormalizado === "CONNECTING" ||
    cStatus === "PAIRING" ||
    cStatus === "TIMEOUT"
  )
}

export function normalizarWhatsAppItem(oItem) {
  if (!oItem || typeof oItem !== "object") {
    return oItem
  }
  return {
    ...oItem,
    status: normalizarStatusConexao(oItem.status),
  }
}

const STATUS_RESET_COMANDO_FALHOU = new Set(["CONNECTING", "QRCODE"])

/**
 * Contrato socket `comando-falhou` não envia `status`; após falha de CRIAR_SESSAO
 * o worker não publica UPDATE de sessão — deriva DISCONNECTED para sair de CONNECTING/QRCODE.
 */
export function statusComandoFalhouResolver(oPayload, oCanalAtual) {
  const cStatusPayload = oPayload?.status
  if (cStatusPayload) {
    return normalizarStatusConexao(cStatusPayload)
  }

  if (oPayload?.tipoComando !== "CRIAR_SESSAO") {
    return undefined
  }

  const cStatusAtual = normalizarStatusConexao(oCanalAtual?.status)
  if (!STATUS_RESET_COMANDO_FALHOU.has(cStatusAtual)) {
    return undefined
  }

  return "DISCONNECTED"
}
